module.exports = __webpack_public_path__ + "img/mingshi.36fc1edc.png";